/*
 * A version of LoadEvent a little more permissive that LoadEvent so it can handle
 *   events where the user doesn't belong (yet)
 */

import { useSelector } from 'react-redux';
import React from 'react';

import { fetchEvent, fetchSubEvent } from '../../data/fetch';
import Loader from './Loader';

const LoadSubEvent = ({ communityId, eventId, children, validate }) => {
    return (
        <Loader skipSpinner={(state) => state.events[eventId]?.event.loaded} promises={[fetchSubEvent(eventId)]}>
            {children}
        </Loader>
    );
};

export default LoadSubEvent;
